export const additionalFilesKey = key => key.split('_')[0] + '_AdditionalFiles_AdditionalImages';

export const checkIfAdditionalFilesQuestion = q => q.key === additionalFilesKey(q.key) ? q : null;



// WEBPACK FOOTER //
// ./src/constants/uploadFiles.js